
import { Alert } from "@/components/ui/alert";
import { AlertTriangle } from "lucide-react";

interface WarningAlertProps {
  message: string;
  className?: string;
}

const WarningAlert = ({ message, className }: WarningAlertProps) => {
  return (
    <Alert 
      variant="destructive" 
      className={`border-destructive/50 text-destructive ${className}`}
    >
      <AlertTriangle className="h-4 w-4" />
      <span>{message}</span>
    </Alert>
  );
};

export default WarningAlert;
